<div [id]="'content'+zona" class="workSpace w3-white">
  <div class="w3-row">
    <div class="w3-row" style="width: 100%; height: 0.5vh;"></div>
    <div class="w3-threequarter headers w3-titulo-contenidomenuSC" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
      <span class="w3-margin-left-contenido">{{tituloZona|translate}}</span>
      @if (subTituloZona) {
        <span class="w3-margin-left-contenido">&bull;</span>
        <span class="w3-margin-left-filter w3-subtitulo" matTooltip="{{subTituloZona}}">{{subTituloZona}}</span>
      }
    </div>
    <div class="w3-rest w3-right">
      @if (type !== types.TABLE) {
        @if(data.length > 1 && etiquetas && type === types.COMBO ){
          <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}"
          (click)="changeLabels('add')" matTooltip="{{'graf.etiquetas'|translate}}">
            new_label
          </mat-icon>
        }
        @if (etiquetas) {
          <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
          (click)="onOffLables()" matTooltip="{{'graf.desactivar'|translate}}">
          label_off
          </mat-icon>
        } @else {
          <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
          (click)="onOffLables()" matTooltip="{{'graf.activar'|translate}}">
            label
          </mat-icon>
        }
      }
      <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}"
      (click)="openModal()" matTooltip="{{'graf.ampliar'|translate}}">
        zoom_out_map
      </mat-icon>
      <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}"
      [matMenuTriggerFor]="menu">
        more_vert
      </mat-icon>
      <mat-menu #menu="matMenu">
        <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="graphicMenu">
          <mat-icon [ngStyle]="{ color: 'gray' }">assessment</mat-icon>
          <span>{{'graf.graficas' | translate}}</span>
        </button>
        @if (perspectivesAvaibable.length !== 0) {
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="perspectivesMenu">
            <mat-icon [ngStyle]="{ color: 'gray' }">assessment</mat-icon>
            <span>{{'graf.perspectives' | translate}}</span>
          </button>
        }
        <mat-divider></mat-divider>
        <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="export()">
          <mat-icon [ngStyle]="{'color':'gray'}">{{type === types.TABLE ? 'description' : 'image'}}</mat-icon>
          <span>{{'menu.Exportar'|translate}}</span>
        </button>
        @if (exportSuc && types.TABLE === type) {
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="export_suc()">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.exportar-suc'|translate}}</span>
          </button>
        }
      </mat-menu>
      <mat-menu #perspectivesMenu="matMenu">
        @for (per of perspectivesAvaibable; track $index) {
          <div [ngClass]="{'w3-disabled':per===perspectiveSelected}">
            <button class="mat-menu-item" mat-menu-item class="w3-caja-menu">
              {{per.name}}
            </button>
          </div>
        }
      </mat-menu>
      <mat-menu #graphicMenu="matMenu">
        @if ( graphicsAvaibable.includes(types.BAR) ) {
          <div [ngClass]="{'w3-disabled':type===types.BAR}">
            <button mat-menu-item (click)="changeGraphic(types.BAR)">
              <mat-icon [ngStyle]="{ color: 'gray' }">bar_chart</mat-icon>
              <span>{{'graf.barras' | translate}}</span>
            </button>
          </div>
        }
        @if ( graphicsAvaibable.includes(types.STACKED) ) {
          <div [ngClass]="{'w3-disabled':type===types.STACKED}">
            <button mat-menu-item (click)="changeGraphic(types.STACKED)">
              <mat-icon [ngStyle]="{ color: 'gray' }">stacked_bar_chart</mat-icon>
              <span>{{'graf.stacked' | translate}}</span>
            </button>
          </div>
        }
        @if ( graphicsAvaibable.includes(types.FUNNEL) ) {
          <div [ngClass]="{'w3-disabled':type===types.FUNNEL}">
            <button mat-menu-item (click)="changeGraphic(types.FUNNEL)">
              <mat-icon [ngStyle]="{ color: 'gray' }">filter_list</mat-icon>
              <span>{{'graf.funnel' | translate}}</span>
            </button>
          </div>
        }
        @if (graphicsAvaibable.includes(types.LINE)) {
          <div [ngClass]="{'w3-disabled':type===types.LINE}">
            <button mat-menu-item (click)="changeGraphic(types.LINE)">
              <mat-icon [ngStyle]="{ color: 'gray' }">show_chart</mat-icon>
              <span>{{'graf.lineal' | translate}}</span>
            </button>
          </div>
        }
        @if (graphicsAvaibable.includes(types.AREA)) {
          <div [ngClass]="{'w3-disabled':type===types.AREA}">
            <button mat-menu-item (click)="changeGraphic(types.AREA)">
              <mat-icon [ngStyle]="{ color: 'gray' }">area_chart</mat-icon>
              <span>{{'graf.area' | translate}}</span>
            </button>
          </div>
        }
        @if (graphicsAvaibable.includes(types.DONUT)) {
          <div [ngClass]="{'w3-disabled':type===types.DONUT}">
            <button mat-menu-item (click)="changeGraphic(types.DONUT)">
              <mat-icon [ngStyle]="{ color: 'gray' }">pie_chart</mat-icon>
              <span>{{'graf.pie' | translate}}</span>
            </button>
          </div>
        }
        @if (graphicsAvaibable.includes(types.HEATMAP)) {
          <div [ngClass]="{'w3-disabled':type===types.HEATMAP}">
            <button mat-menu-item (click)="changeGraphic(types.HEATMAP)">
              <mat-icon [ngStyle]="{ color: 'gray' }">view_quilt</mat-icon>
              <span>{{'graf.calor' | translate}}</span>
            </button>
          </div>
        }
        @if (graphicsAvaibable.includes(types.COMBO)) {
          <div [ngClass]="{'w3-disabled':type===types.COMBO}">
            <button mat-menu-item (click)="changeGraphic(types.COMBO)">
              <mat-icon [ngStyle]="{ color: 'gray' }">bar_chart</mat-icon>
              <span>{{'graf.combinada' | translate}}</span>
            </button>
          </div>
        }
        @if (graphicsAvaibable.includes(types.TABLE)) {
          <div [ngClass]="{'w3-disabled':type===types.TABLE}">
            <button mat-menu-item (click)="changeGraphic(types.TABLE)">
              <mat-icon [ngStyle]="{ color: 'gray' }">table_chart</mat-icon>
              <span>{{'graf.tabla' | translate}}</span>
            </button>
          </div>
        }
      </mat-menu>
    </div>
  </div>
  <div class="containerGrafica">
    @if (type !== types.TABLE && data.length !== 0) {
      <app-graficador
        #graficador1
        [zona]="zona*10+1"
        [data]="data"
        [labels]="labels"
        [type]="type"
        [colors]="colors"
        [axisY]="axisY"
        [animations]="animations"
        [etiquetas]="etiquetas"
        [distributed]="type === types.DONUT || type === types.DONUT"
        [altoEtiquetasX]="100"
        (eventClick)="clickSeries($event)"
      />
    }@else if(data.length !== 0) {
      <div class="w3-scroll" style="height: 98%;">
        <table  class="w3-table borderInfLow">
          <thead>
              <tr class="w3-center w3-table-title">
                <th class="stikyColum w3-border-right-balance">
                  
                </th>
                @for (cat of dataTable; track $index) {
                  <th class="stikyColum w3-border-right-balance">
                    {{cat.name}}
                  </th>
                  <th class="stikyColum w3-border-right-balance">
                    %
                  </th>
                }
              </tr>
          </thead>
          <tbody>
            @for (lab of labels; track lab; let i = $index) {
              <tr class="w3-table-trtd">
                <td class="borderAllLow">
                  {{lab}}
                </td>
                @for (dat of dataTable; track $index) {
                  <td class="borderAllLow alinRight marginDer">
                    {{dat.valores[i]}}
                  </td>
                  <td class="borderAllLow alinRight marginDer">
                    {{dat.porcentaje[i]}} %
                  </td>
                }
              </tr>
              @if(i === labels.length-1){
                <tr class="w3-table-titleLow">
                  <td class="borderAllLow">
                    {{'comercial.asosiatividad.perfil.total' | translate}}
                  </td>
                  @for (dat of dataTable; track $index) {
                    <td class="borderAllLow alinRight marginDer">
                      {{dat.valores[i+1]}}
                    </td>
                    <td class="borderAllLow alinRight marginDer">
                      {{dat.porcentaje[i+1]}} %
                    </td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>   
      </div>
    }
  </div>
</div>

<!-- <div [id]="'ampliar'+zona" class="modal" (click)="clickFuera($event)">
  <div class="modalContent fadingIn">
    <div class="modalHeader w3-titulo-contenidomenu">
      <div class="w3-threequarter">
        <span>{{tituloZona|translate}}</span>
      </div>
      <div class="w3-rest w3-right">
        @if (type !== types.TABLE) {
          @if( data.length > 1 && etiquetas && type === types.COMBO ){
            <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="changeLabels('add')" matTooltip="{{'graf.etiquetas'|translate}}">
              new_label
            </mat-icon>
          }
          @if (etiquetas) {
            <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
            (click)="onOffLables()" matTooltip="{{'graf.desactivar'|translate}}">
            label_off
            </mat-icon>
          } @else {
            <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
            (click)="onOffLables()" matTooltip="{{'graf.activar'|translate}}">
              label
            </mat-icon>
          }
        }
        <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}" 
        (click)="export()" matTooltip="{{'menu.exportar'|translate}}">
          description
        </mat-icon>
      </div>
    </div>
    <div class="modalBod" style="width: 75vw; margin-bottom: 2vh;" [ngStyle]="{ 'height': type===types.TABLE?'auto':'60vh' }">
      <div style="height: 95%; width: 98%; margin-left: auto; margin-right: auto;">
        @if (type !== types.TABLE) {
          <app-graficador
            [zona]="zona*10+2"
            [data]="data"
            [labels]="labels"
            [type]="type"
            [colors]="colors"
            [axisY]="axisY"
            [animations]="false"
            [etiquetas]="etiquetas"
            (eventClick)="clickSeries($event)"
          />
        }@else {
          <table  class="w3-table borderInfLow">
            <thead>
                <tr class="w3-center w3-table-title">
                  <th class="stikyColum w3-border-right-balance">
                    
                  </th>
                  @for (cat of dataTable; track $index) {
                    <th class="stikyColum w3-border-right-balance">
                      {{cat.name}}
                    </th>
                    <th class="stikyColum w3-border-right-balance">
                      %
                    </th>
                  }
                </tr>
            </thead>
            <tbody>
              @for (lab of labels; track lab; let i = $index) {
                <tr class="w3-table-trtd">
                  <td class="borderAllLow">
                    {{lab}}
                  </td>
                  @for (dat of dataTable; track $index) {
                    <td class="borderAllLow alinRight marginDer">
                      {{dat.valores[i]}}
                    </td>
                    <td class="borderAllLow alinRight marginDer">
                      {{dat.porcentaje[i]}} %
                    </td>
                  }
                </tr>
                @if(i === labels.length-1){
                  <tr class="w3-table-titleLow">
                    <td class="borderAllLow">
                      {{'comercial.asosiatividad.perfil.total' | translate}}
                    </td>
                    @for (dat of dataTable; track $index) {
                      <td class="borderAllLow alinRight marginDer">
                        {{dat.valores[i+1]}}
                      </td>
                      <td class="borderAllLow alinRight marginDer">
                        {{dat.porcentaje[i+1]}} %
                      </td>
                    }
                  </tr>
                }
              }
            </tbody>
          </table>  
        }
      </div>
    </div>
  </div>
</div> -->

<app-modal [isOpen]="modal" (close)="closeModal()" [export]="true" [iconoExport]="type === types.TABLE ? 'description' : 'image'" (exportFile)="export()">
  <div modal-header>
    {{tituloZona|translate}}
  </div>
  <div modal-body>
    <div class="spaceGrafica">
      @if (type !== types.TABLE && graficaAmpliar) {
        <div class="zonaGrafAmp">
          <app-graficador #graficadorModal
            [data]="data"
            [labels]="labels"
            [type]="type"
            [colors]="colors"
            [axisY]="axisY"
            [animations]="animations"
            [etiquetas]="etiquetas"
            [zona]="zona*10+2"
          />
        </div>
      }@else {
        <table class="w3-table borderInfLow">
          <thead>
              <tr class="w3-center w3-table-title">
                <th class="stikyColum w3-border-right-balance">
                  
                </th>
                @for (cat of dataTable; track $index) {
                  <th class="stikyColum w3-border-right-balance">
                    {{cat.name}}
                  </th>
                  <th class="stikyColum w3-border-right-balance">
                    %
                  </th>
                }
              </tr>
          </thead>
          <tbody>
            @for (lab of labels; track lab; let i = $index) {
              <tr class="w3-table-trtd">
                <td class="borderAllLow">
                  {{lab}}
                </td>
                @for (dat of dataTable; track $index) {
                  <td class="borderAllLow alinRight marginDer">
                    {{dat.valores[i]}}
                  </td>
                  <td class="borderAllLow alinRight marginDer">
                    {{dat.porcentaje[i]}} %
                  </td>
                }
              </tr>
              @if(i === labels.length-1){
                <tr class="w3-table-titleLow">
                  <td class="borderAllLow">
                    {{'comercial.asosiatividad.perfil.total' | translate}}
                  </td>
                  @for (dat of dataTable; track $index) {
                    <td class="borderAllLow alinRight marginDer">
                      {{dat.valores[i+1]}}
                    </td>
                    <td class="borderAllLow alinRight marginDer">
                      {{dat.porcentaje[i+1]}} %
                    </td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>  
      }
    </div>
 </div>
</app-modal>

<div [id]="'exportar'+zona" class="workSpace w3-white" style="top: 0px; left: 0; z-index: -10; position: absolute;">
  <div class="w3-row headers w3-titulo-contenidomenuSC" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
    <span class="w3-margin-left-contenido">{{tituloZona|translate}}</span>
    @if (subTituloZona) {
      <span class="w3-margin-left-contenido">&bull;</span>
      <span class="w3-margin-left-filter w3-subtitulo" matTooltip="{{subTituloZona}}">{{subTituloZona}}</span>
    }
  </div>
  <div class="containerGrafica">
    <div [id]="'graficaExport'+zona"></div>
  </div>
</div>
              